import { createTheme, responsiveFontSizes } from '@mui/material/styles'

const primaryColor = '#4277b9'
const secondaryColor = '#35d89c'

const theme = createTheme({
  palette: {
    primary: { main: primaryColor },
    secondary: { main: secondaryColor },
    background: {
      default: '#f7f9fc'
    }
  },
  typography: {
    fontFamily: ['Roboto', 'Helvetica Neue', 'Arial', 'sans-serif'].join(', '),
    h4: { fontWeight: 800, letterSpacing: '-0.4px' },
    h6: { fontWeight: 700 }
  },
  shape: { borderRadius: 14 },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          border: '1px solid rgba(0,0,0,0.06)',
          boxShadow: '0 8px 28px rgba(15, 23, 42, 0.06)'
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none' as const }
      }
    }
  }
})

export default responsiveFontSizes(theme)
export { primaryColor, secondaryColor }
